import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostDataSecurityAlertRequest = {
	hide?: boolean;
	monitorAlertId: number;
};

export const postDataSecurityAlert = createPostEndpoint<PostDataSecurityAlertRequest>(
	'/api/v3/data-security/alerts/'
);
